module.exports = __webpack_public_path__ + "popup_close.36d74bd96e44ad3e6609f4e84dc79129.png";